// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import gc_rsa from "gc_rsa";
import "@/utils/requestNew.js";
const ENV = process.env.NODE_ENV;
let appkey = "";
let appsecret = "";

if (process.env.appkey){
	appkey = process.env.appkey;
}
if (process.env.appsecret) {
	appsecret = process.env.appsecret;
}
if (process.env.supportWeb&&process.env.supportWeb=='T') {
  sessionStorage.setItem('debugMode', 'T');
}
if (appkey && appsecret){
	gc_rsa({
		appkey,
		appsecret,
		engineType: "fly",
		// adapter: "wx"
	});
	sessionStorage.setItem('gateway', "T");
}else{
	sessionStorage.setItem('gateway', "");
}
import router from "./router";
// import VueAwesomeSwiper from 'vue-awesome-swiper'
import "babel-polyfill";
import store from "./store";
import "styles/reset.css";
import "styles/border.css";
import "styles/iconfont.css";
import "swiper/dist/css/swiper.css";
import "@/styles/animate.min.css";
import "@/styles/layer.css";
import api from "@/utils/api";
import waterfall from 'vue-waterfall2'
Vue.use(waterfall)
import {
  globalMethods
} from "@/mixin/mixin.js";
import {
  setStorage,
  getStorage,
  removeStorage
} from "@/utils/wxuser";
import {
  isWeChat,
  scriptLoad,
  initGcTrack,
  getQueryStringFromUrl,
  getCookie
} from "@/utils/utils";
import {
  baseUrl
} from "@/utils/baseUrl";
import Es6Promise from "es6-promise";
import VueLazyload from "vue-lazyload";
import VueScroller from "vue-scroller"
import Vconsole from "vconsole";
import $d from "@/utils/devices.js";
import '@/api/lib-flexible.js';
import DatePickerScroll from "vue-datepicker-scroll";
import gc from "@/utils/gc";
import gcTrack from "@/utils/gcTrack";
import IPhoneBottomHeight from "@/components/IPhoneBottomHeight";
import vHtml from "@/components/vHtml";
Vue.component("IPhoneBottomHeight", IPhoneBottomHeight);
Vue.component("vHtml", vHtml);
import {
  List,
  PullRefresh,
  Picker,
  Calendar,
  Popup
} from 'vant';

Vue.prototype.$gc = gc;
window.$gc = gc;
Es6Promise.polyfill();
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(VueScroller);
Vue.use(DatePickerScroll)
Vue.use(Calendar);
Vue.use(Picker);
Vue.use(Popup);

Vue.mixin(globalMethods);
Vue.config.productionTip = false;
Vue.use(VueLazyload, {
  error: "https://xcx.ihotel.cn/hotel/images/noPic.png",
  loading: "https://xcx.ihotel.cn/hotel/images/noPic.png",
  try: 2
});
let url = window.location.href;
let debug = getQueryStringFromUrl(url, 'debug') ? getQueryStringFromUrl(url, 'debug') : "";
if (!debug){
	debug = sessionStorage['debug'];
}

if (debug =="T") {
	sessionStorage['debug'] = debug;
	(function () { var script = document.createElement('script'); script.src = "https://cdn-1251575231.cos.ap-shanghai.myqcloud.com/eruda/2.5.0/eruda.js"; document.body.appendChild(script); script.onload = function () { eruda.init() } })();
	/* const vConsole = new Vconsole();
	Vue.use(vConsole); */
}

const jsApiList = [
  "checkJsApi",
  "translateVoice",
  "startRecord",
  "stopRecord",
  "chooseImage",
  "previewImage",
  "uploadImage",
  "downloadImage",
  "getNetworkType",
  "openLocation",
  "getLocation",
  "closeWindow",
  "scanQRCode",
  "chooseWXPay",
  "openProductSpecificView",
  "closeWindow",
  "onMenuShareTimeline",
  "onMenuShareAppMessage",
  "openAddress",
  "hideOptionMenu",
  "showOptionMenu",
];
api.findByDomain({
    domain: window.location.host,
    isWarn: "F"
  })
  .then(res => {
    console.log(res)
    if (res.result == 1) {
      
      let config = JSON.parse(res.msg);

      // if ( window.__wxjs_environment === "miniprogram") {
      //   setStorage("isMiniAppH5", "T");
      //   config.channel = 'mini_app'
      //   config.clientType = 'wechat_mini'
      //   config.linkType = '2'
      // }else{
      //   setStorage("isMiniAppH5", "");
      //   config.channel = 'WECHAT'
      //   config.clientType = 'wechat'
      //   config.linkType = '1'
      // }

      let appid = "";
      if(getStorage('appid')){
        appid = getStorage('appid')
      }
      if (getQueryStringFromUrl(window.location.href, 'appid')) {
        appid = getQueryStringFromUrl(window.location.href, 'appid');
      }
      if ( window.__wxjs_environment == "miniprogram"||/miniProgram/i.test(navigator.userAgent.toLowerCase())) {
        config.miniAppid = appid
      }
      config.channel = 'WECHAT'
      config.clientType = 'wechat'
      config.linkType = '1'
      config['domain'] = window.location.origin;
      window.config = config;
      setStorage("config", config);
      // let colorTheme = getStorage('colorTheme');
      // if (colorTheme) {
      //   document.body.style.setProperty("--colorTheme", colorTheme);
      // }

      api.buildSignature({
          appid: config.appid,
          componentAppid: config.componentAppid,
          url: location.href.split('#')[0]
          // url: window.location.origin + baseUrl
        })
        .then(res => {
          if (res.result == 1) {
            wx.config({
              // debug: ENV === "development" ? true : false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              debug:false,
              appId: config.appid, // 必填，公众号的唯一标识
              timestamp: Number(res.retVal.timestamp), // 必填，生成签名的时间戳
              nonceStr: res.retVal.noncestr, // 必填，生成签名的随机串
              signature: res.retVal.signature, // 必填，签名
              jsApiList: jsApiList // 必填，需要使用的JS接口列表,
            });
            wx.ready(() => {
              

            });
          }
        });
      var codes = ["isOpenHighWechat","isOpenOnlinePayUnion","isOpenLinksarefans","isOpenGlobalSafe","isOpenMixedPayment","isOpenTravelAgencyMode","customPack","GlobalGrey","isOpenConsumerCard,isHideCardSwitch","crossGroupPointExchange","chuzhiCardReplace,goodsShareShowDisName","colorTheme", "isOpenVconsole", "isOpenTrackEvent", "creditName", "isOpenProfitSharingShopCart", "gcPayTransMode4Shop","isOpenCardBag","cardBagName","isHiddenCoupon","isOpenPromotionValue","isOpenRightsCoupon","isHiddenChuzhiCard"];
      var self = this;
      var params = {
        appid: config.appid,
        codes: codes.join(","),
        componentAppid: config.componentAppid,
        hotelCode: config.hotelCode ? config.hotelCode : 0,
        hotelGroupCode: config.hotelGroupCode,
        clientType: config.clientType
      };
      var gcPayTransMode4Shop = ''
      api
        .getMultiSysOptionCommonForHigh(params)
        .then(data => {
          if (data.result == 1) {
            data.retVal.forEach(function (n, i) {
              if (n.code == "isOpenHighWechat") {
								setStorage('isOpenHighWechat', n.value);
              }
              if (n.code == "isOpenOnlinePayUnion") {
								setStorage('isOpenOnlinePayUnion', n.value);
              }
              if (n.code == "isOpenLinksarefans" && n.value) {
								setStorage('isOpenLinksarefans', n.value);
							}
              if (n.code == "isOpenGlobalSafe" && n.value) {
								setStorage('isOpenGlobalSafe', n.value);
							}
              if (n.code == 'isHiddenCoupon' && n.value) {
								setStorage('isHiddenCoupon', n.value)
							}
              if (n.code == 'isOpenPromotionValue' && n.value) {
								setStorage('isOpenPromotionValue', n.value)
							}
              if (n.code == 'isOpenRightsCoupon' && n.value) {
								setStorage('isOpenRightsCoupon', n.value)
							}
              if (n.code == 'isHiddenChuzhiCard' && n.value) {
								setStorage('isHiddenChuzhiCard', n.value)
							}
              if (n.code == 'isOpenMixedPayment' && n.value) {
								setStorage('isOpenMixedPayment', n.value)
							}
              if (n.code == 'cardBagName' && n.value) {
								setStorage('cardBagName', n.value)
							}
              if (n.code == 'isOpenTravelAgencyMode' && n.value) {
								if(n.value=='T'){
									setStorage('isOpenTravelAgencyMode', n.value)
								}
							}
              if(n.code == "crossGroupPointExchange"){
                setStorage('crossGroupPointExchange', n.value)
              }
              if(n.code == "customPack"){
                setStorage('customPack', n.value)
              }
              if(n.code == "goodsShareShowDisName"){
                if (n.value) {
                  setStorage('goodsShareShowDisName', n.value)
                }
              }
              if (n.code == "GlobalGrey") {
								if (n.value == "T") {
									document.getElementsByTagName('html')[0].style.cssText += 'filter: grayscale(100%);'
								}
							}
              if (n.code == "chuzhiCardReplace") {
								setStorage('chuzhiCardReplace', n.value);
							}
              if(n.code=="isOpenConsumerCard"){
                setStorage('isOpenConsumerCard', n.value);
              }
              // if (n.code == "isOpenVconsole") {
              //   if (n.value && n.value == 'T') {
              //     const vConsole = new Vconsole();
              //     Vue.use(vConsole);
              //   }
              // }

              if (n.code == "isOpenTrackEvent") {
                if (n.value == "T") {
                  let config = getStorage("config");
                  gc.init({
                    appid: config.appid,
                    hotelGroupCode: config.hotelGroupCode,
                    hotelCode: config.hotelCode,
                    serverUrl: "/datacenterapi/behaviourDetails/saveBehaviourDetails"
                  });
                  initGcTrack();

                }
              }
              if (n.code == "gcPayTransMode4Shop" && n.value) {
                setStorage('gcPayTransMode4Shop', n.value)
                gcPayTransMode4Shop = n.value
              }
              if (n.code == "creditName" && n.value) {
                setStorage('creditName', n.value)
              }
              if (n.code == "isOpenProfitSharingShopCart" && n.value) {
                setStorage('isOpenProfitSharingShopCart', n.value)
              }
              if (n.code == "isOpenCardBag" && n.value) {
                setStorage('isOpenCardBag', n.value)
              }
              if (n.code == "isHideCardSwitch" && n.value) {
                setStorage('isHideCardSwitch', n.value)
              }
              
            });
            if (gcPayTransMode4Shop != '07') {
              removeStorage('mainOpenid')
            }else{
              if(!getStorage('mainOpenid')){
                if(getCookie('mainOpenid')){
                  setStorage('mainOpenid', getCookie('mainOpenid'))
                }
               
              }
            }
            var obj = {
              hotelGroupCode: config.hotelGroupCode,
              channel: "WECHAT",
              appid: config.appid,
              businessType:'2'
            }
            api.shopStyleConfig(obj).then((res) => {
              document.body.style.setProperty("--mainColor", '#1E1E1E');
              document.body.style.setProperty("--subColor", '#EBECF2');
              document.body.style.setProperty("--priceColor", '#e55141');
              document.body.style.setProperty("--priceFontFamily", 'lvyun');
              document.body.style.setProperty("--priceFontSizeBig", '18px');
              document.body.style.setProperty("--labelColor", '#9265f5');
              document.body.style.setProperty("--priceFontSize", '14px');
              document.body.style.setProperty("--priceFontSizeLarge", '20px');
              if (res.result == 1) {
                if (res.retVal[0] && res.retVal[0].fontType == '1') {
                  document.body.style.setProperty("--priceFontFamily", 'PingFangSC-Semibold');
                  document.body.style.setProperty("--priceFontSize", '14px');
                  document.body.style.setProperty("--priceFontSizeLarge", '20px');
                }
                if (res.retVal[0] && res.retVal[0].fontColor&&res.retVal[0].fontColor != '') {
                  document.body.style.setProperty("--priceColor", res.retVal[0].fontColor);
                }
                if (res.retVal[0] && res.retVal[0].color != '') {
                  var colors = res.retVal[0].color.split(',')
                  if (colors[0]) {
                    document.body.style.setProperty("--mainColor", colors[0]);
                  }
                  if (colors[1]) {
                    document.body.style.setProperty("--subColor", colors[1]);
                  }

                }
                if (res.retVal[0] && res.retVal[0].mallLabelColor) {
                  document.body.style.setProperty("--labelColor",  res.retVal[0].mallLabelColor);
                }
              }
              var opt = {
                hotelGroupCode: config.hotelGroupCode,
                hotelCode: config.hotelCode,
                configItem: 'shop_goods_time_limit,closeAccountQrcode,close_sms_pay,weComCS,no_password_pay,showOrderGame,hotelPickUpPoint,polymerization_reward_tips,goods_partial_refund,hideHotelInfo,indexHotelGoods,hover_all_type,isOpenNameJudgmentOfResidents,show_list_hotelName,priceOrCredit,mall_template,goodsListTowColumn,closeWaterfall,isOpenVconsole,isCloseShopCart,appointPageUrl,isSquarePic,isQrCode,ShopShareRewardContent,identity_pictrue,idCard_required'
              }
              removeStorage('no_password_pay')
              removeStorage('indexHotelGoods')
              removeStorage('hoverAllType')
              removeStorage('isOpenNameJudgmentOfResidents')
              removeStorage('appointPageUrl')
              removeStorage('isCloseShopCart')
              removeStorage('goodsListTowColumn')
              removeStorage('isSquarePic')
              removeStorage('isQrCode')
              removeStorage('ShopShareRewardContent')
              removeStorage('closeWaterfall')
              removeStorage('isNeedIdPic')
              removeStorage('priceOrCredit')
              removeStorage('showListHotelName')
              removeStorage('hotelPickUpPoint')
              removeStorage('weComCS')
              removeStorage('close_sms_pay')
              removeStorage('shop_goods_time_limit')
              api.batchQueryShopConfig(opt).then(data => {
                if (data.result == 1) {
                  data.retVal.forEach(item => {
                    if(item.configItem ==  'shop_goods_time_limit'){
                      if (item.itemValue) {
                        setStorage('shop_goods_time_limit', item.itemValue);
                      }
                    }
                    if(item.configItem ==  'closeAccountQrcode'){
                      if (item.itemValue) {
                        setStorage('closeAccountQrcode', item.itemValue);
                      }
                    }
                    if(item.configItem ==  'close_sms_pay'){
                      if (item.itemValue) {
                        setStorage('close_sms_pay', item.itemValue);
                      }
                    }
                    if(item.configItem ==  'weComCS'){
                      if (item.itemValue) {
                        setStorage('weComCS', item.itemValue);
                      }
                    }
                    if(item.configItem ==  'no_password_pay'){
                      if (item.itemValue) {
                        setStorage('no_password_pay', item.itemValue);
                      }
                    }
                    if(item.configItem ==  'showOrderGame'){
                      if (item.itemValue) {
                        setStorage('showOrderGame', item.itemValue);
                      }
                    }
                    if(item.configItem ==  'polymerization_reward_tips'){
                      if (item.itemValue) {
                        setStorage('polymerization_reward_tips', item.itemValue);
                      }
                    }
                    if(item.configItem ==  'goods_partial_refund'){
                      if (item.itemValue) {
                        setStorage('goods_partial_refund', item.itemValue);
                      }
                    }
                    if (item.configItem == 'hover_all_type') {
                      if (item.itemValue) {
                        setStorage('hoverAllType', item.itemValue);
                      }
                    }
                    if (item.configItem == 'isOpenNameJudgmentOfResidents') {
                      if (item.itemValue) {
                        setStorage('isOpenNameJudgmentOfResidents', item.itemValue);
                      }
                    }
                    if (item.configItem == 'priceOrCredit') {
                      if (item.itemValue) {
                        setStorage('priceOrCredit', item.itemValue);
                      }
                    }
                    if (item.configItem == 'mall_template') {
                      if (item.itemValue) {
                        setStorage('mallTemplate', Number(item.itemValue));
                      }
                    }
                    if (item.configItem == 'goodsListTowColumn') {
                      if (item.itemValue) {
                        setStorage('goodsListTowColumn', item.itemValue);
                      }
                    }
                    if (item.configItem == 'closeWaterfall') {
                      if (item.itemValue&&item.itemValue=='T') {
                        setStorage('closeWaterfall', item.itemValue);
                      }
                    }
                    if (item.configItem == 'isOpenVconsole') {
                      const vConsole = new Vconsole();
                      Vue.use(vConsole);
                    }
                    if (item.configItem == 'isCloseShopCart') {
                      if (item.itemValue) {
                        setStorage('isCloseShopCart', item.itemValue);
                      }
                    }
                    if (item.configItem == 'isSquarePic') {
                      if (item.itemValue) {
                        setStorage('isSquarePic', item.itemValue);
                      }
                    }
                    if (item.configItem == 'appointPageUrl') {
                      if (item.itemValue) {
                        setStorage('appointPageUrl', item.itemValue);
                      }
                    }
                    if (item.configItem == 'ShopShareRewardContent') {
                      if (item.itemValue) {
                        setStorage('ShopShareRewardContent', item.itemValue);
                      }
                    }
                    if (item.configItem == 'identity_pictrue') {
                      if (item.itemValue) {
                        setStorage('isNeedIdPic', item.itemValue);
                      }
                    }
                    if (item.configItem == 'idCard_required') {
                      if (item.itemValue) {
                        setStorage('idCardRequired', item.itemValue);
                      }
                    }
                    if (item.configItem == 'isQrCode') {
                      if (item.itemValue&&item.itemValue=='T') {
                        try {
                          var describeInfo = JSON.parse(item.describeInfo)
                          var qrCodeUrl = ''
                          describeInfo.forEach(qrCode=>{
                            if(qrCode.appid==config.appid){
                              qrCodeUrl = qrCode.url
                            }
                          })
                          setStorage('isQrCode', qrCodeUrl);
                        } catch (error) {
                          
                        }
                       
                      }
                    }
                    if(item.configItem == 'show_list_hotelName'){
                      if (item.itemValue) {
                        setStorage('showListHotelName', item.itemValue);
                      }
                    }
                    if(item.configItem=='indexHotelGoods'){
                      if (item.itemValue) {
                        setStorage('indexHotelGoods', item.itemValue);
                      }
                    }
                    if (item.configItem == 'hideHotelInfo') {
                      if (item.itemValue) {
                        setStorage('hideHotelInfo', item.itemValue);
                      }
                    }
                    if(item.configItem == 'hotelPickUpPoint'){
                      if (item.itemValue) {
                        setStorage('hotelPickUpPoint', item.itemValue);
                      }
                    }
                  });
                }
                initVue();
              }).catch(err => {
                initVue();
              })
            }).catch(err => {
              initVue();
            })

          }
        })
        .catch(err => {
          if (gcPayTransMode4Shop != '07') {
            removeStorage('mainOpenid')
          }
          initVue();
          console.log(err);
        });
    } else {
      document.write("findByDomain接口获取基础数据失败");
    }
  })
  .catch(function (error) {
    document.write("findByDomain请求超时");
  });

function initVue() {
  new Vue({
    el: "#app",
    router,
    store,
    components: {
      App
    },
    template: "<App/>"
  });
}
(function () {
  if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
    handleFontSize();
  } else {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", handleFontSize);
      document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
    }
  }

  function handleFontSize() {
    // 设置网页字体为默认大小
    WeixinJSBridge.invoke('setFontSizeCallback', {
      'fontSize': 0
    });
    // 重写设置网页字体大小的事件
    WeixinJSBridge.on('menu:setfont', function () {
      WeixinJSBridge.invoke('setFontSizeCallback', {
        'fontSize': 0
      });
    });
  }
})();
//IOS监听

(function () {
  var isPageHide = false;
  window.addEventListener("pageshow", function () {
    if (isPageHide) {
      window.location.reload();
    }
  });
  window.addEventListener("pagehide", function () {
    isPageHide = true;
  });
})();

let isReset = true; //是否归为
if ($d.device() === "ios") {
  // document.body.addEventListener("focusin", () => {
  //   //软键盘弹出的事件处理
  //   isReset = false;
  // });
  // document.body.addEventListener("focusout", () => {
  //   //软键盘收起的事件处理
  //   isReset = true;
  //   setTimeout(() => {
  //     //当焦点在弹出层的输入框之间切换时先不归位
  //     if (isReset) {
  //       window.scroll(0, 0); //失焦后强制让页面归位
  //     }
  //   }, 300);
  // });
} else if ($d.device() === "android") {
  window.onresize = function () {
    //键盘弹起与隐藏都会引起窗口的高度发生变化
    let resizeHeight =
      document.documentElement.clientHeight || document.body.clientHeight;
    if (resizeHeight < h) {
      //当软键盘弹起，在此处操作
      isReset = false;
    } else {
      //当软键盘收起，在此处操作
      isReset = true;
      setTimeout(() => {
        if (isReset) {
          window.scroll(0, 0); //失焦后强制让页面归位
        }
      }, 300);
    }
  };
}



// WEBPACK FOOTER //
// ./src/main.js